import React, { useContext, useEffect } from "react";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
export function useAppId() {
  const { appRuntimeEnv } = useContext(GlobalContext);
  // useEffect(() => {
  //     console.log('appRuntimeEnv.runtimeConfig.key in ----', appRuntimeEnv.runtimeConfig.key);
  // }, [appRuntimeEnv])
  return appRuntimeEnv.runtimeConfig.key === "mebj" ? "mebj" : "";
}
